import axios from "axios";
import { createTransactionID } from "../utils";
import { CREATE_SHOPPING_CART_DEMAND_REQ, CREATE_SHOPPING_CART_INSTALLATION_REQ } from "../constants";

const win: any = window;

let config = {
    api: {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
    },
};

export const api = axios.create({ ...config.api });
export const simpleApi = axios.create();

api.defaults.validateStatus = function () {
    return true;
};

api.interceptors.request.use(
    async (conf: any) => {
        conf.baseURL = win["apigee_bm_base_url"];
        conf.headers['cem-key'] = win["cem_key"];
        conf.headers['x-api-key'] = win["cem_key"];
        conf.headers["X-Source-Channel"] = "PORTAL";
        conf.headers["X-Transaction-Id"] = createTransactionID();
        conf.headers["Authorization"] = `Bearer ${win['bmToken']}`;
        if (!win['correlationId']) win['correlationId'] = createTransactionID(true)
        conf.headers['x-correlation-id'] = win['correlationId'];
        conf.headers["X-Journey-Name"] = win['requestFlow'] === 'installation' ? "FTTH_Installation_Request" : "FTTH_Demand_Request"
        return conf;
    }, (err) => {
        console.log("error in getting ", err);
    }
);

api.interceptors.response.use(
    async (response: any) => {
        return response;
    }, async (error: any) => {
        if (!!win["errorPageURL"]) {
            document.location.href = win["errorPageURL"];
        }
        return error;
    }
);

const sendOtp = (data: any) => {
    return api.post('/cem/bff/profile/tahaquq/v1/verify', data);
    // return api.get('http://localhost:3001/taqquOTP');
    // return api.get('http://localhost:3001/taqqOTPError');
};

const resendOtp = (data: any) => {
    return api.put('/cem/bff/otp/v1/resend', data);
};

const validateOTP = (data: any) => {
    return api.put('/cem/bff/otp/v1/validate', data);
    // return api.get('http://localhost:3001/validateOTP', data);
};

const createShoppingCart = (requestFlow: string) => {
    return api.post('/shopping-cart/v3/shoppingCart', requestFlow==='installation' ? CREATE_SHOPPING_CART_INSTALLATION_REQ : CREATE_SHOPPING_CART_DEMAND_REQ)
}

const shoppingCartUpdateAndValidate = (id: string) => {
    return api.post('/mobily-shopping-cart-management/api/update-and-validate', {
        "ShoppingCartId": id,
        // "JourneyName": "FTTH_Demand_Request"
    })
}

const shoppingCartStructure = (payload: any) => {
    return api.post('/checkout-api/v3/checkout/structure', payload)
}

const postInitiatePayment = (data: any) => {
    return api.post('/cem/bff/ecom/ftth-installation/v1/initiatePayment', data)
}

const captureData = (payload: any) => {
    return api.post('/checkout-api/v3/checkout/captureData', payload)
}

const validateCaptureData = (payload: any) => {
    return api.post('/checkout-api/v3/checkout/validate', payload)
}

const postProductOrder = (data: any) => {
    return api.post('/cem/order-generator/ftth-demand/v1/postProductOrder', data)
    // return api.get('http://localhost:3001/ftthPostProductOrder', data)
}

const completeProductOrderApi = (data: any) => {
    return api.post('/cem/order-generator/ftth-installation/v1/postProductOrder', data)
    // return api.get('http://localhost:3001/ftthPostProductOrder', data)
}

export { 
    sendOtp,
    validateOTP,
    resendOtp,
    createShoppingCart,
    shoppingCartUpdateAndValidate,
    shoppingCartStructure,
    captureData,
    postProductOrder,
    validateCaptureData,
    postInitiatePayment,
    completeProductOrderApi
};